export const NotFoundRoute = () => <div>Not found</div>
